export const invoiceStateData = {
  vendorInvoicePairs: [
    {
      vendorNo: '2035',
      invoiceId: 'N043024E1'
    },
    {
      vendorNo: '2035',
      invoiceId: 'N043024E2'
    },
    {
      vendorNo: '2035',
      invoiceId: 'N043024E3'
    },
    {
      vendorNo: '2035',
      invoiceId: 'N043024E4'
    },
    {
      vendorNo: '2008',
      invoiceId: 'N043024E5'
    },
    {
      vendorNo: '2008',
      invoiceId: 'N043024E6'
    },
    {
      vendorNo: '2008',
      invoiceId: 'N043024E7'
    },
    {
      vendorNo: '2008',
      invoiceId: 'N043024E8'
    },
    {
      vendorNo: '2008',
      invoiceId: 'N043024E9'
    }
  ]
};
